import { serviceLocator } from '@/utils/providers/serviceLocator'
import { BranchRepository } from '../repositories/BranchRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function getBranchByIdCase(id: number) {
  const newRepository = serviceLocator.getService<BranchRepository>('BranchService')

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getBranchById(id),
    key: 'branch',
    filterData: JSON.stringify(id)
  })
  if (data.value?.error) return
  return data.value
}
